"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootTypeCode = exports.TypeCode = void 0;
exports.asTypeCode = asTypeCode;
var TypeCode;
(function (TypeCode) {
    TypeCode["NetStub"] = "5";
    TypeCode["PageBorder"] = "6";
    TypeCode["PowerSymbol"] = "7";
    TypeCode["WireBundle"] = "8";
    TypeCode["BusSegment"] = "10";
    TypeCode["WireSegment"] = "11";
    TypeCode["ComponentInstance"] = "12";
    TypeCode["Terminal"] = "13";
    TypeCode["PageMetadata"] = "14";
    TypeCode["GraphicsLineArrow"] = "25";
    TypeCode["GraphicsCallout"] = "28";
    TypeCode["GraphicsHtml"] = "29";
    TypeCode["VisualLabel"] = "31";
    TypeCode["GraphicsImage"] = "33";
    TypeCode["PropList"] = "37";
    TypeCode["PropBlock"] = "40";
    TypeCode["PageInstance"] = "55";
})(TypeCode || (exports.TypeCode = TypeCode = {}));
var RootTypeCode;
(function (RootTypeCode) {
    RootTypeCode[RootTypeCode["Master"] = 3] = "Master";
    RootTypeCode[RootTypeCode["Page"] = 4] = "Page";
})(RootTypeCode || (exports.RootTypeCode = RootTypeCode = {}));
const TYPE_CODE_VALUES = new Set(Object.values(TypeCode));
function asTypeCode(s) {
    return TYPE_CODE_VALUES.has(s) ? s : null;
}
//# sourceMappingURL=typeCodes.js.map